<script>
import { getFileTypeLogo } from '@/utils/modules/getStyles.js'
import { changeSeconds, hightText, filtersRichtext } from '@/utils/common.js'

export default {
  name: 'SearchResComponent',
  props: {
    searchResItem: {
      type: Object,
      default: () => {}
    },
    searchVal: {
      type: String,
      default: ''
    }
  },
  methods: {
    getFileTypeLogo, changeSeconds, hightText, filtersRichtext
  }
}
</script>

<template>
  <div>
    <div class="search-res-component">
      <div v-if="searchResItem.type === '图文' || searchResItem.type === '视频'" class="item-left left-article">
        <el-image v-if="searchResItem.photo" class="item-img" :src="searchResItem.photo | imgPath" alt="img" fit="cover" />
        <div class="item-content">
          <p class="right-title h-line-1" v-html="hightText(searchResItem.headline, searchVal)" />
          <p v-if="searchResItem.memo" class="right-memo h-line-2" v-html="hightText(filtersRichtext(searchResItem.memo), searchVal)" />
        </div>
      </div>

      <div v-if="searchResItem.type === '文件'" class="item-left left-article">
        <el-image class="item-img" :src="getFileTypeLogo(searchResItem.typename)" alt="img" fit="cover" />
        <div class="item-content">
          <p class="right-title h-line-2" v-html="hightText(searchResItem.headline, searchVal)" />
        </div>
      </div>

      <div v-if="searchResItem.type === '人员公示'" class="item-left left-article">
        <el-image class="item-img" :src="searchResItem.photo | userAvator" alt="img" fit="cover" />
        <div class="item-content member-item-content">
          <p class="right-title h-line-1" v-html="hightText(searchResItem.name, searchVal)" />
          <p class="right-title h-line-1">职务: {{ searchResItem.post }}</p>
          <p class="right-title h-line-1">联系方式: {{ searchResItem.phone }}</p>
          <!-- <p class="right-title h-line-1">联系方式: {{ searchResItem.phone | hiddenPhone }}</p> -->
        </div>
      </div>

      <div v-if="searchResItem.type === '音频'" class="item-left left-article">
        <el-image class="item-img item-img-audio" :src="getFileTypeLogo(searchResItem.typename)" alt="img" fit="cover" />
        <div class="item-content">
          <p class="right-title" v-html="hightText(searchResItem.headline, searchVal)" />
          <p class="right-memo right-title-audio">
            <span>来源 -- {{ searchResItem.name }}</span>
            <span>时长: {{ changeSeconds(searchResItem.time, 'str') }}</span>
          </p>
        </div>
      </div>

      <div class="item-right">
        <p class="label" :class="{'label-member': searchResItem.type.length > 3}">{{ searchResItem.type }}</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.search-res-component {
  width: 450px;
  height: 115px;
  background-color: #F9F9F9;
  border-radius: 20px;
  padding: 15px;
  box-sizing: border-box;
  cursor: pointer;
  display: grid;
  grid-template-columns: 1fr 74px;
  column-gap: 16px;
}
.left-article {
  display: flex;
  align-items: center;
  column-gap: 14px;
  .item-img {
    flex-shrink: 0;
    width: 85px;
    height: 85px;
    border-radius: 12px;
  }
  .item-img-audio {
    padding: 10px;
  }
  .item-content {
    height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    row-gap: 14px;
    .right-title {
      font-size: 18px;
      font-weight: bold;
    }
    .right-memo {
      font-size: 14px;
      color: #B3B3B3;
    }
    .right-title-audio {
      color: #B3B3B3;
      display: flex;
      align-items: center;
      span:first-child {
        margin-right: 10px;
        position: relative;
        display: flex;
        align-items: center;
        &::after {
          content: '';
          position: absolute;
          left: 104%;
          width: 1px;
          height: 13px;
          background-color: #B3B3B3;
        }
      }
    }
  }
  .member-item-content {
    row-gap: 6px;
  }
}
.item-right {
  display: flex;
  justify-content: flex-end;
  .label {
    // width: 70px;
    height: 22px;
    padding: 0 12px;
    box-sizing: border-box;
    border: 1px solid #B3B3B3;
    border-radius: 4px;
    font-size: 12px;
    color: #999;
    display: grid;
    place-items: center;
  }
  .label-member {
    padding: 0 2px;
  }
}
</style>
